import Payment from './Payment';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

export default {
  list: Payment,
  icon: ReceiptOutlinedIcon
};